import React from "react";
import { Car, Users, Award } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const HeroStats = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const statsData = labels.menuPages?.sellCar?.hero?.stats || [];

  const icons = [
    <Car className="w-6 h-6 md:w-8 md:h-8 text-emerald-400" />,
    <Users className="w-6 h-6 md:w-8 md:h-8 text-cyan-400" />,
    <Award className="w-6 h-6 md:w-8 md:h-8 text-purple-400" />,
  ];
  const colors = ["text-emerald-400", "text-cyan-400", "text-purple-400"];

  return (
    <div className="grid grid-cols-3 gap-3 sm:gap-6 md:gap-8 max-w-2xl mx-auto px-2">
      {statsData.map((stat: any, index: number) => (
        <div
          key={index}
          className="text-center p-3 sm:p-4 md:p-6 rounded-xl md:rounded-2xl bg-white/5 backdrop-blur-xl border border-white/10"
        >
          <div className="flex justify-center mb-2 md:mb-3">
            {icons[index] || icons[0]}
          </div>
          <div className="text-lg md:text-2xl font-bold text-white">
            {stat.number || ""}
          </div>
          <div className="text-xs md:text-sm text-gray-400">
            {stat.label || ""}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HeroStats;
